import { ReactElement } from 'react'
import Layout from '../components/layout'
import FileManager from '../components/FileManager'

const FileManagerPage = (): ReactElement => {
  return (
    <Layout>
      <FileManager />
    </Layout>
  )
}

export default FileManagerPage
